import { Loader2 } from 'lucide-react';

const LoadingOverlay = ({ message = 'Loading data...' }) => {
  return (
    <div 
      className="fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center"
      data-testid="loading-overlay"
    >
      <div className="flex flex-col items-center gap-4 p-8 rounded-xl bg-white shadow-lg border">
        <Loader2 className="w-12 h-12 text-blue-600 animate-spin" />
        <div className="text-center">
          <p className="text-lg font-semibold text-slate-800">{message}</p>
          <p className="text-sm text-slate-500 mt-1">Please wait...</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
